// eslint-disable-next-line import/prefer-default-export
export const dividerMargin = '5px';
